'use strict';

var cov_1k1f2albsh = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.stories.factory.js',
        hash = 'ea6a06ce2996a5a0d814a4b8690f1b6c3ada066e',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.stories.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 43,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 49
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 41,
                    column: 11
                }
            },
            '3': {
                start: {
                    line: 38,
                    column: 20
                },
                end: {
                    line: 38,
                    column: 43
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 43,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 38
                    },
                    end: {
                        line: 42,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 37,
                        column: 24
                    },
                    end: {
                        line: 37,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 37,
                        column: 41
                    },
                    end: {
                        line: 39,
                        column: 17
                    }
                },
                line: 37
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1k1f2albsh.s[0]++;
(function () {
    'use strict';

    cov_1k1f2albsh.f[0]++;
    cov_1k1f2albsh.s[1]++;
    angular.module('app').factory('StoriesTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_1k1f2albsh.f[1]++;
        cov_1k1f2albsh.s[2]++;


        return restmod.model('/stories').mix('MixinContainable', {
            $extend: {
                Collection: {
                    $limit: 1000
                }
            },
            $config: {
                contains: {
                    tasks: {
                        type: 'hasMany',
                        table: 'TasksTable',
                        foreignKey: 'story'
                    },
                    project: {
                        type: 'belongsTo',
                        table: 'ProjectsTable',
                        foreignKey: 'project'
                    },
                    proposal: {
                        type: 'belongsTo',
                        table: 'ProposalsTable',
                        foreignKey: 'proposal'
                    }
                }
            },
            updated: {
                decode: function decode(value) {
                    cov_1k1f2albsh.f[2]++;
                    cov_1k1f2albsh.s[3]++;

                    return new Date(value);
                }
            }
        });
    }
})();